import{
    apiRequest,
    polaKerjaPegawaiDetail,
    polaKerjaPegawaiUpdate,
    employeeListcreate,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/polaKerjaPegawaiService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", polaKerjaPegawaiDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", polaKerjaPegawaiUpdate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeListcreate, {
            params: query
        }, true)
    }
    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default UpdateRepository